
import { BLOG_ARTICLES } from '@/const/api/blog';
import LayoutContainer from '@/components/layout/Container';

export default {
    name: 'Blog',
    head: {
        title: 'Блог платформы Ко-Фи: полезные материалы',
        meta: [
            { 
                hid: 'og:title',
                name: 'og:title',
                property: 'og:title',
                content: 'Блог платформы Ко-Фи: полезные материалы'
            },
            {
                hid: 'description',
                name: 'description',
                content: 'Новости платформы, советы для предпринимателей и инвесторов.',
            },
            { 
                hid: 'og:description',
                name: 'og:description',
                property: 'og:description',
                content: 'Новости платформы, советы для предпринимателей и инвесторов.'
            },
        ]
    },
    data() {
       return {
           latestArticle: null,
           rightBlockArticles: [],
           topBlockArticles: [],
           bottomBlockArticles: [],
           articles: [],
           popularArticles: [],
           meta: null,
           loading: false
       }
    },
    async fetch() {
        await this.fetchArticles({
            limit: 13
        }).then(({data}) => {
            if (data?.items) {
                this.latestArticle = data.items.length ? data.items.slice(0, 1)[0] : null
                this.rightBlockArticles = data.items.slice(1, 4)
                this.topBlockArticles = data.items.slice(4, 7)
                this.bottomBlockArticles = data.items.slice(7)
                this.articles = data.items || []
            }
            this.meta = data?.meta
        })

        await this.fetchArticles({
            type: 1,
            limit: 4
        }).then(({data}) => {
            this.popularArticles = data?.items || []
        })
    },
    methods: {
        async fetchArticles(params) {
            return await this.$axios(BLOG_ARTICLES, {params})
        },
        handleLoadArticles() {
            this.loading = true;
            this.fetchArticles({
                page: this.meta.page + 1,
                limit: 13
            })
                .then(({ data }) => {
                    if (data?.items) {
                        this.articles = this.articles.concat(data.items);
                        this.bottomBlockArticles = this.bottomBlockArticles.concat(data.items);
                    }
                    if (data?.meta) this.meta = data.meta;
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    },
    components: {
        LayoutContainer,
    },
}
